import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    container: {
        maxHeight: 350,
        overflow: 'auto'
    }
}))